import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const EmailFilledIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 4-8 5-8-5V6l8 5 8-5z"
      fill="currentColor"
    />
  </svg>
);

EmailFilledIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(EmailFilledIcon);
